import React, { Fragment, useMemo, memo } from 'react'
import injectSheet from 'react-jss'
import styles from './slide.styles'
import Slide from '../../../components/slide/slide.jsx'
import classNames from 'classnames'
import ImageBox from 'pobble-components/dist/image-box'
import placeholder from 'pobble-components/dist/presentation/image-image-placeholder.svg'
import Heading from '../../../components/heading/heading.jsx'
import SlideText from '../../../components/slide-text/slide-text.jsx'
import ScrollFade from '../../../components/scroll-fade/scroll-fade.jsx'
import {
  usePresentation,
  withPresentation
} from '../../../presentation-connectors'

const ImageSlide = memo(({ classes, slides, id }) => {
  const presentation = usePresentation()

  const data = slides[id]

  const onImgClick = useMemo(() => {
    const slideState = presentation.slidesState[data.id]
    if (!slideState || !slideState.onImgClick) return undefined
    return slideState.onImgClick
  }, [presentation.slidesState, data.id])

  const slideData = useMemo(() => {
    let image =
      data.use_presentation_image &&
      presentation.image &&
      presentation.image.url
    image = !image ? data.image && data.image.url : image
    return {
      image,
      title: data.title,
      html: data.html_text,
      position: data.imagePosition,
      size: data.image_size
    }
  }, [data, presentation.image])

  return (
    <Slide
      className={classNames(classes.container, {
        [classes.positionLeft]: slideData.position === 'left',
        [classes.positionRight]: slideData.position === 'right',
        [classes.positionCenter]: slideData.position === 'center',
        [classes.positionFill]: slideData.size === 'fill',
        [classes.clickable]: slideData.position === 'fill' && !slideData.image
      })}
      onClick={
        slideData.position === 'fill' && !slideData.image ? onImgClick : null
      }>
      <Fragment>
        <div className={classes.imageContainer}>
          <ImageBox
            fill={slideData.size === 'fill'}
            onImgClick={!slideData.image ? onImgClick : null}
            key={slideData.position}
            src={slideData.image || placeholder}
            alt="Visuals box"
            className={classes.imageBox}
          />
        </div>
        <div
          className={classNames(classes.descContainer, {
            [classes.centerDesc]: !slideData.html
          })}>
          <div className={classes.descHolder}>
            {slideData.title && (
              <Heading className={classNames(classes.title)}>
                {slideData.title}
              </Heading>
            )}
            {slideData.html && (
              <SlideText className={classes.desc} html={slideData.html} />
            )}
          </div>
          <ScrollFade />
        </div>
      </Fragment>
    </Slide>
  )
})

export default withPresentation(injectSheet(styles)(ImageSlide))
